import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { StateService } from '@uirouter/angular';

import { UserauthApiService } from 'src/app/api/services/userauth-api.service';

@Component({
    selector: 'reset-password-confirm',
    templateUrl: './reset-password-confirm.component.html',
    styleUrls: ['./reset-password-confirm.component.scss'],
    standalone: false
})
export class ResetPasswordConfirmComponent {

  credentials: any = {};
  errors = {};

  emailResetSent = false;
  invalidToken = false;
  loading;

  @ViewChild('resetPasswordForm')
  public resetPasswordForm: NgForm;

  constructor(private stateService: StateService,
    private userauth: UserauthApiService) {}

  _resetErrorStates() {
    this.emailResetSent = false;
    this.invalidToken = false;
  }

  resetPassword() {
    this._resetErrorStates();

    if (this.resetPasswordForm.valid) {
      this.loading = true;
      this.userauth.resetPassword(this.stateService.params.user, this.stateService.params.token, this.credentials.newPassword)
        .then(() => {
          console.log('Password updated');
          this.stateService.go('apps.auth.unauthorized', {
            passwordReset: true
          });
        })
        .catch((err) => {
          var error = err.result && err.result.error && err.result.error.message;

          if (error === 'Password reset token does not match') {
            this.invalidToken = true;
          } else {
            console.error(err);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  requestPasswordReset() {
    this._resetErrorStates();

    this.loading = true;
    this.userauth.requestPasswordReset(this.stateService.params.user)
      .then(() => {
        console.log('Email sent');
        this.emailResetSent = true;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

}